/*
 * @Author       : Duanjiaojiao
 * @Date         : 2025-04-23 15:46:33
 * @LastEditors  : Duanjiaojiao
 * @LastEditTime : 2025-08-29 14:28:37
 * @Description  :
 * @FilePath     : /BM-Main/src/utils/env.js
 */
/**
 * @Author ZhangYing
 * @Date 2022-04-24 14:55:39
 * @LastEditors ZhangYing
 * @LastEditTime 2025-06-23 19:31:09
 * @Description
 * @FilePath /BM-Main/src/utils/env.js
 * @props
 */
import native from '@zz-common/native-adapter'
import { env, cookie, url } from '@zz-common/zz-utils'
import { getFeApolloInfoAjax } from '@/apiData/common'

const externalEnvConfig = ['toutiao', 'kuaishou']

export const isExternalEnv = externalEnvConfig.includes(native.getClient())

export const $isiPhone14 = (function() {
  if (!env.$isIOS) return false;
  const _window$screen2 = window.screen;
  const width = _window$screen2.width;
  const height = _window$screen2.height;
  const isiPhone14Pro = window.devicePixelRatio === 3 && width === 393 && height === 852;
  return isiPhone14Pro
}());

export const $isiPhoneXsMax = (function() {
  if (!env.$isIOS) return false;
  const _window$screen2 = window.screen;
  const width = _window$screen2.width;
  const height = _window$screen2.height;
  const iPhoneXsMax = window.devicePixelRatio === 3 && width === 414 && height === 896;
  return iPhoneXsMax
}());
/**T值 小程序会在url中获取t值 */
let objT = url.getParam('__t')
if (!objT) {
  objT = cookie.get('t')
} else {
  objT = Array.isArray(objT) ? objT[0] : objT
}
export const isPlumWa = objT == 262
export const isPlum = native.in('plum')
export const inPlum = isPlum || isPlumWa

export const isToutiaoEnv = native.in('toutiao')

export const isKuaishouEnv = native.in('kuaishou')

export const isIphoneX = env.$isiPhoneX || env.$isiPhone12 || $isiPhone14 || $isiPhoneXsMax

export const isIOS = env.$isIOS

export const isAndroid = env.$isAndroid

export const isOpenHarmony = env.$isOpenHarmony

export const inZZ = native.in('zz') || native.in('zzseller') || native.in('zzhunter')

export const inZLJ = native.in('zlj') || (native.in('wa') && cookie.get('t') == 141)

export const inZZ_APP = native.in('zz')

export const inZLJ_APP = native.in('zlj')

/**T值 小程序会在url中获取t值 */
const _t = url.getParam('__t') || cookie.get('t')

// 高德环境判断，一期高德不给提供任何技术支持，ua也不知道，暂时通过t值判断
export const inGAODE = _t == 186

// 支付宝小程序环境判断，198是转转回收，199是转转上门回收
export const inALI_PAY = _t == 198 || _t == 199

// 转转主程序
export const inZZ_WA = _t == 103

// 是否外部回收
let tList = []
export const isExternalRecycle = async() => {
  try {
    const currentT = url.getParam('__t') || cookie.get('t')
    if (!tList?.length) {
      tList = await getFeApolloInfoAjax({ keys: 'bm-external-recylce' })
    }
    return tList?.map(item => item.t).includes(+currentT)
  } catch (error) {
    return false
  }
}

// 在转转小程序打开链接
export const openInWA = url => {
  const _url = encodeURIComponent(url)
  return `zhuanzhuan://jump/core/miniProgram/jump?goDirectly=1&miniprogramType=0&path=${encodeURIComponent('pages/webview/bridge?url=' + _url)}&userName=gh_c2980df66965`
}

export const inGoldRecycleAliPay = _t == 268

// 熊店长app(大屏&手机&pad端)
export const inZZStore = [74, 154, 155].includes(Number(_t))
// 是否是门店大屏app
export const isStoreLargeScreen = _t == 74

// 是否是门店大屏app，不同于 isStoreLargeScreen 该方法是通过UA判断因为新旧大屏的 t 值是一样的
export const isNewLargescreen = (() => {
  return window.navigator.userAgent.indexOf('zzApp/storevaluation') > -1
})()

export const isZZwa = env.$isZzMiniprogram
export const isStoreWa = _t == 137
